import { useState } from "react";
import useAuthStore from "../store/authStore";

const BASE_URL = import.meta.env.VITE_APP_URL ?? "https://joborigo.com";

export default function CopyResumeLink({ className = "" }) {
  const seekerUser = useAuthStore((s) => s.seekerUser);
  const [copied, setCopied] = useState(false);

  if (!seekerUser?.resume_slug) return null;

  const resumeUrl = `${BASE_URL}/r/${seekerUser.resume_slug}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(resumeUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      // Fallback for browsers that block clipboard
      const input = document.createElement("input");
      input.value = resumeUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`flex items-center gap-2 text-sm font-medium transition ${
        copied
          ? "text-green-600 dark:text-green-400"
          : "text-brand-violet dark:text-brand-violet-on-dark hover:opacity-80"
      } ${className}`}
    >
      {copied ? (
        <>
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          Copied!
        </>
      ) : (
        <>
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
          Copy resume link
        </>
      )}
    </button>
  );
}
